"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.transform = void 0;
var proj4_1 = __importDefault(require("proj4"));
var srs_1 = require("../../srs");
var pointFactory_1 = require("../pointFactory");
var isFilled_1 = require("./isFilled");
var transform = function (point, srsTo) {
    if (!(0, isFilled_1.isFilled)(point))
        return null;
    var x = point.x, y = point.y, srs = point.srs;
    if (srs === srsTo) {
        return point;
    }
    var srsFromObj = srs_1.SRSs.getSRSByCode(srs);
    if (!srsFromObj) {
        return null;
    }
    var srsToObj = srs_1.SRSs.getSRSByCode(srsTo);
    if (!srsToObj) {
        return null;
    }
    try {
        var _a = (0, proj4_1["default"])(srsFromObj.wkt, srsToObj.wkt, [x, y]), long = _a[0], lat = _a[1];
        return pointFactory_1.PointFactory.createInstance({ srs: srsToObj.code, x: long, y: lat });
    }
    catch (error) {
        return null;
    }
};
exports.transform = transform;
//# sourceMappingURL=transform.js.map